export default {"src":"/_next/static/media/StatusBar-Dots.8082b232.svg","height":7,"width":27,"blurWidth":0,"blurHeight":0};